// src/webhooks/monitoring-priority-fields.ts
var e = Object.freeze({
	checkly: "priority",
	datadog: "priority",
	grafana: "alerts[i].labels.solidops_priority",
	prtg: "solidops_priority"
});
export { e as MONITORING_PRIORITY_FIELDS };

//# sourceMappingURL=monitoring-priority-fields.js.map